import { roleActionTypes as actionType } from 'src/constants/actionTypes';

const initialState = {
  list: [],
  success: '',
  error: '',
};

const roleReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.GET_ALL_SUCCESS: {
      const { roles } = action.payload;
      return {
        ...state,
        list: roles,
      };
    }

    case actionType.GET_SUCCESS: {
      const { role } = action.payload;
      return {
        ...state,
        selectedRole: { ...state.selectedRole, ...role },
      };
    }

    case actionType.GET_REPOSITORIES_SUCCESS: {
      const { repositories } = action.payload;
      return {
        ...state,
        selectedRole: { ...state.selectedRole, repositories },
      };
    }

    case actionType.GET_USERS_SUCCESS: {
      const { users } = action.payload;
      return {
        ...state,
        selectedRole: { ...state.selectedRole, users },
      };
    }

    case actionType.UPDATE_SUCCESS: {
      const { updatedRole, successMsg } = action.payload;

      const newList = state.list.map((role) => ((role.id === updatedRole.id) ? updatedRole : role));

      return {
        ...state,
        list: newList,
        success: successMsg,
      };
    }

    case actionType.CREATE_SUCCESS: {
      const { role, successMsg } = action.payload;
      return {
        ...state,
        list: [...state.list, role],
        success: successMsg,

      };
    }

    case actionType.DELETE_SUCCESS: {
      const { id, successMsg } = action.payload;
      const filteredList = state.list.filter((role) => role.id !== id);

      return {
        ...state,
        list: filteredList,
        success: successMsg,
      };
    }

    case actionType.FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        error
      };
    }

    case actionType.CLEAR_MESSAGES: {
      return {
        ...state,
        success: '',
        error: ''
      };
    }

    default: {
      return state;
    }
  }
};

export default roleReducer;
